import InputWithLabelT from '@components/tailwind-components/Input/InputWithLabelT';
import type { Control, FieldValues, Path } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

type TimeIntervalInputProps<T extends FieldValues> = {
  nameFrom: Path<T>;
  nameTo: Path<T>;
  disabled?: boolean;
  control: Control<T>;
};

export function TimeIntervalInput<T extends FieldValues>({
  nameFrom,
  nameTo,
  disabled,
  control,
}: TimeIntervalInputProps<T>) {
  const { t } = useTranslation();

  return (
    <div className='flex flex-start items-center gap-5'>
      <div className='min-w-[70px] max-w-[70px]'>
        <InputWithLabelT
          type='text'
          field={nameFrom}
          placeholder={t('handover-settings.interval.from')}
          label={t('handover-settings.interval.from')}
          control={control}
          options={{
            disabled: disabled,
          }}
        />
      </div>
      <div className='min-w-[70px] max-w-[70px]'>
        <InputWithLabelT
          type='text'
          field={nameTo}
          placeholder={t('handover-settings.interval.to')}
          label={t('handover-settings.interval.to')}
          control={control}
          options={{
            disabled: disabled,
          }}
        />
      </div>
    </div>
  );
}
